<template>
  <v-dialog v-model="dialog" persistent scrollable width="800px">
    <v-card>
      <v-card-title class="admin white--text text-uppercase">
        {{ !isEdit ? 'Thêm mới Popup' : 'Cập nhật Popup' }}
        <v-spacer />
        <v-btn icon @click="closeDialog"><v-icon color="white">mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form ref="form">
          <div class="text-body-2 font-weight-bold mb-3">1. Nội dung sẽ hiển thị trên APP</div>
          <PictureInput
            :key="imageKey"
            ref="pictureInput"
            width="600"
            height="600"
            margin="16"
            accept="image/jpeg, image/png, image/jpg"
            size="10"
            button-class="btn"
            :hideChangeButton="true"
            :zIndex="0"
            :custom-strings="{
              upload: '<b>Thiết bị không hỗ trợ tải lên file ảnh</b>',
              drag: 'Kéo vào để upload ảnh hiển thị trên app',
            }"
            @change="onChangeImage"
            :prefill="image"
          />

          <v-switch
            v-model="isExternalLink"
            dense
            hide-details
            :label="!isExternalLink ? 'Trỏ liên kết trong APP' : 'Trỏ liên kết ra bên ngoài APP'"
            class="mb-3"
          />
          <v-text-field
            v-model="linkTo"
            clearable
            flat
            outlined
            label="Nhập URL cần liên kết"
            placeholder="https://youtube.com"
            v-if="isExternalLink"
          />
          <v-autocomplete
            v-else
            dense
            label="Liên kết tới"
            v-model="linkTo"
            :items="[
              {title: 'Trang chủ', value: '/'},
              {title: 'Trang danh sách HS', value: '/cv'},
              {title: 'Trang đăng nhập', value: '/login', title: 'Trang đăng ký', value: '/register'},
            ]"
            item-text="title"
            item-value="value"
            outlined
            flat
            hide-details
          />

          <v-divider class="my-4" />

          <div class="text-body-2 font-weight-bold mb-3">2. Các thông tin liên quan</div>
          <v-text-field
            v-model="title"
            label="Tiêu đề"
            placeholder="Yêu cầu đăng ký"
            clearable
            flat
            outlined
            dense
            :rules="[$rules.required]"
            type="text"
          />
          <v-text-field
            v-mask="'##/##/####'"
            placeholder="VD: 01/01/2026"
            name="login"
            v-model="deadline"
            type="text"
            color="primary"
            :rules="[$rules.required]"
            outlined
            validate-on-blur
            label="Hạn hiển thị"
            dense
          />
          <v-autocomplete
            dense
            label="Hiển thị cho"
            v-model="appliedType"
            :items="[
              {title: 'Tất cả', value: 'all'},
              {title: 'Chưa đăng nhập', value: 'nonAuth'},
              {title: 'Đã đăng nhập', value: 'auth'},
              {title: 'Có HS theo khối', value: 'auth-grade'},
            ]"
            item-text="title"
            item-value="value"
            outlined
            flat
          />
          <v-autocomplete
            class="ml-3"
            v-if="appliedType === 'auth-grade'"
            dense
            label="Chọn khối"
            v-model="appliedForGrades"
            :items="[{title: 'Khối 6'}, {title: 'Khối 10'}]"
            item-text="title"
            item-value="title"
            outlined
            flat
            multiple
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-spacer />
        <v-btn @click="onSubmit" color="admin" class="white--text">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import PictureInput from 'vue-picture-input'
import {mapActions} from 'vuex'
export default {
  components: {PictureInput},
  data: () => ({
    dialog: false,
    image: null,
    title: null,
    deadline: null,
    isExternalLink: false,
    linkTo: '/',
    appliedType: 'all',
    appliedForGrades: [],
    imageKey: Date.now(),
    isEdit: false,
    id: null,
  }),
  methods: {
    ...mapActions({createItem: 'adsPopup/createItem', updateItem: 'adsPopup/updateItem', upload: 'upload/upload'}),
    onChangeImage(image) {
      if (image) {
        this.image = this.$refs.pictureInput.file
      }
    },
    openDialog({isEdit, ...data}) {
      if (isEdit) {
        this.id = data.id
        this.image = data.imageUrl
        this.title = data.title
        this.deadline = moment(data.deadline).format('DD/MM/YYYY')
        this.isExternalLink = data.isExternalLink
        this.appliedType = data.appliedType
        this.appliedForGrades = data.appliedForGrades
        this.isEdit = true
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.imageKey = Date.now()
    },
    uploadImage(image) {
      let formData = new FormData()
      formData.append('files', image)
      formData.append('refId', Date.now().toString())
      formData.append('field', 'imageObj')
      return this.upload(formData)
    },
    formatDeadlineToSave(deadline = '') {
      const [d, m, y] = deadline.split('/')
      return moment([y, m, d].join('-') + 'T17:00:00.000Z')
        .subtract(1, 'day')
        .toISOString()
    },
    getDataToSave() {
      return {
        title: this.title,
        deadline: this.formatDeadlineToSave(this.deadline),
        linkTo: this.linkTo,
        isExternalLink: this.isExternalLink,
        appliedType: this.appliedType,
        appliedForGrades: this.appliedForGrades,
      }
    },
    async onCreate() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return this.$alert.error('Vui lòng nhập đầy đủ thông tin')
      if (!this.image) return this.$alert.error('Vui lòng tải lên file ảnh')

      this.$loading.active = true
      try {
        const images = await this.uploadImage(this.image)
        await this.createItem({
          ...this.getDataToSave(),
          imageObj: images[0].id,
          imageUrl: process.env.VUE_APP_API_ENDPOINT + images[0].url.slice(1),
        })

        this.$emit('onRefresh')
        this.$alert.success('Tạo Popup thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async onUpdate() {
      let imageUrl = ''
      const isImageFile = !this.image && typeof this.image === 'string' && !this.image.startsWith('http')
      if (isImageFile) {
        const images = await this.uploadImage(this.image)
        imageUrl = process.env.VUE_APP_API_ENDPOINT + images[0].url.slice(1)
      }
      const data = this.getDataToSave()
      if (imageUrl.length) data['imageUrl'] = imageUrl
      this.$loading.active = true
      try {
        await this.updateItem({id: this.id, ...data})

        this.$emit('onRefresh')
        this.$alert.success('Cập nhật Popup thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    onSubmit() {
      if (!this.id) return this.onCreate()
      else return this.onUpdate()
    },
  },
}
</script>